import ErrorIcon from "@mui/icons-material/Error";
import { Alert, Box, SxProps, useTheme, AlertTitle} from "@mui/material";

const lightBgColor = "#FFDDDB";
const lightBorderColor = "#F04438";
const darkBgColor = "#412A29";
const darkBorderColor = "#593534";

export const AlertBanner = ({
  errorMessage,
  sx = {},
  title = undefined
}: {
  errorMessage: React.ReactNode | string;
  sx: SxProps;
  title?: string
}) => {
  const { palette } = useTheme();

  return (
    <Alert
      severity="error"
      icon={<ErrorIcon color="error" fontSize="small" />}
      sx={{
        width: "100%",
        mb: 2,
        border: "1px solid",
        borderColor:
          palette.mode === "light" ? lightBorderColor : darkBorderColor,
        backgroundColor: palette.mode === "light" ? lightBgColor : darkBgColor,
        fontSize: "14px",
        color: palette.text.primary,
        pr: 1,
        pl: 0.5,
        py: 0,
        "& > MuiAlert-icon": { mr: 1 },
        ...sx,
      }}
    >
      <Box>
        <AlertTitle>{title}</AlertTitle>
        {errorMessage}
      </Box>
    </Alert>
  );
};